import * as actionTypes from '../constants/collectionConstants';
import axios from 'axios';

export const getAllCollections = () => async(dispatch) =>{
    try{
        dispatch({ type: actionTypes.COLLECTION_REQUESTS });
        const {data} = await axios.get('/api/v1/a/AllCollections');
console.log(data);
        dispatch({
            type: actionTypes.COLLECTION_REQUESTS_SUCCESS,
            payload: data,
        })
    }catch (error){
        dispatch({
            type: actionTypes.COLLECTION_REQUESTS_FAIL,
            payload: error.response && error.response.data.message ? error.response.data.message : error.message,
        });
    }
};